"use client";
import React from "react";
import L from "leaflet";
import { Map, Marker, Popup, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import {
  getLabelsData,
  getPortfolioData,
} from "../../api/portfolio/PortfolioData";
import ButtonDefault from "../button/button-default/ButtonDefault";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { dsnCN } from "../../hooks/helper";
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";
import "leaflet-gesture-handling";
import { useRef } from "react";

L.Map.addInitHook("addHandler", "gestureHandling", L.GestureHandling);

const marker = L.divIcon({
  className: "",
  html: `
    <div class="marker">
      <img src="/assets/img/marker.png" />
    </div>
  `,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -45],
});

const markerCircle = L.divIcon({
  className: "",
  html: `
    <div class="marker">
      <img src="/assets/img/marker-circle.png" />
    </div>
  `,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -45],
});

function FantasyMap({ tag: Tag = "div" }) {
  const mapRef = useRef();

  const position = [-25.409512051967805, 24.185714721679688];
  const bounds = [
    [-47.63435549616143, -74.89764477125061],
    [26.8025596347974, 75.07156728591727],
  ];

  const markers = getPortfolioData().filter((item) => item.lat && item.lon);
  const labels = getLabelsData();

  // console.log("Markers:", markers);

  const handleClick = (e) => {
    console.log("Clicked coordinates:", e.latlng.lat, e.latlng.lng);
  };

  return (
    <Tag
      className={dsnCN(
        "map-container half-content v-dark-head background-main",
      )}
      style={{ padding: "80px 0 0 0" }}
    >
      <Map
        ref={mapRef}
        center={position}
        zoom={5}
        zoomControl={false}
        minZoom={5}
        maxZoom={6}
        style={{ height: "98%", width: "100%" }}
        maxBounds={bounds}
        maxBoundsViscosity={1.0}
        onClick={handleClick}
        scrollWheelZoom={false}
        doubleClickZoom={false}
        attributionControl={false}
        gestureHandling={true}
      >
        <TileLayer url="/assets/img/map/tiles/{z}/{x}/{y}.png" noWrap={true} />

        {markers.map((m, i) => (
          <Marker
            key={i}
            position={[m.lat, m.lon]}
            icon={m.category.includes("Music") ? markerCircle : marker}
          >
            <Popup>
              <div className="popup-container">
                <img
                  alt={m.title + m.category}
                  src={m.src}
                  style={{ width: "100%" }}
                />

                <div className="description">
                  <h6>{m.title}</h6>
                  <p>{m.description || "No description available."}</p>
                </div>

                <div className="action">
                  <img
                    alt={m.title}
                    src={
                      m.category.includes("Music")
                        ? "assets/img/services/bard.png"
                        : "assets/img/services/ice.png"
                    }
                    width={30}
                    title={m.category}
                  />

                  <ButtonDefault
                    href={m.link}
                    className="mt-30"
                    text={m.buttonText || "View More"}
                    icon={faAngleRight}
                    target="_blank"
                    onClick={() => {
                      if (mapRef.current) {
                        mapRef.current.leafletElement.closePopup();
                      }
                    }}
                  />
                </div>
              </div>
            </Popup>
          </Marker>
        ))}

        {labels.map((label, i) => (
          <Marker
            key={`label-${i}`}
            position={[label.lat, label.lon]}
            icon={L.divIcon({
              className: "map-label-icon",
              html: `<span class="map-label">${label.name}</span>`,
            })}
          />
        ))}
      </Map>
    </Tag>
  );
}

export default FantasyMap;
